<div *ngIf="loading">
    <div class="loader main" style="display: none;">
        <div class="loading-screen">
            <div class="spinner">
                <img [src]="'assets/images/spinner.svg'" alt="Spinner" />
            </div>
        </div>
    </div>
</div>